import React from "react";
import { Link, useLocation } from "react-router-dom";
import { Phone, MessageCircle } from "lucide-react";
import { SITE } from "@/site";

/**
 * Sticky bottom CTA bar — visible only on mobile (lg:hidden).
 * Hidden on the contact, thank-you and lead form pages to avoid duplication.
 */
export default function StickyMobileCTA() {
    const { pathname } = useLocation();
    const hidden = pathname === "/contact" || pathname === "/thank-you";
    if (hidden) return null;

    return (
        <div
            data-testid="sticky-mobile-cta"
            className="lg:hidden fixed bottom-0 left-0 right-0 z-40 bg-black/95 backdrop-blur-xl border-t border-gold/20 px-3 py-2.5 flex items-center gap-2 pb-[calc(0.625rem+env(safe-area-inset-bottom))]"
        >
            <a
                href={`tel:${SITE.phoneTel}`}
                aria-label="Call studio"
                className="flex items-center justify-center w-12 h-12 rounded-full border border-white/15 text-white hover:border-gold hover:text-gold transition-colors shrink-0"
            >
                <Phone className="w-4 h-4" />
            </a>
            <Link
                to="/contact"
                data-testid="sticky-mobile-book-btn"
                className="flex-1 inline-flex items-center justify-center bg-gold text-black font-semibold text-sm px-4 py-3 rounded-full hover:bg-gold-hover transition-colors"
            >
                Book Free Trial Class
            </Link>
            <a
                href={SITE.whatsapp}
                target="_blank"
                rel="noreferrer"
                aria-label="WhatsApp"
                className="flex items-center justify-center w-12 h-12 rounded-full bg-[#25D366] text-white shrink-0"
            >
                <MessageCircle className="w-4 h-4" />
            </a>
        </div>
    );
}
